import React from 'react';
import {observer} from 'mobx-react-lite';
import {Col, Row} from 'antd';
import {Barcode} from '../shared/Barcode';
import {EnDash} from '../shared/unicodeWrapper/EnDash';

const LastCreatedBatch = ({batch}) => {
  if (!batch) {
    return '';
  }

  return (
    <Row gutter={16} style={{margin: '2rem 0'}}>
      <Col xs={24} lg={16} xl={12}>
        <div
          className={'roboto-mono'}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
            border: '1px solid #000000',
            fontSize: '1rem',
            color: '#000000',
          }}
        >
          {batch.no || <EnDash/>}
        </div>
      </Col>
      <Col xs={24} lg={16} xl={12} style={{display: 'flex'}}>
        <Barcode value={batch.no} displayValue={false} margin={0}/>
      </Col>
    </Row>
  );
};

export default observer(LastCreatedBatch);
